import type { Plugin } from 'vue';
import ComponentWrapper from '@/components/standard-components/ComponentWrapper.vue';
import SectionTitle from '@/components/standard-components/SectionTitle.vue';
import SentenceDropdownDeprecated from '@/components/standard-components/SentenceDropdownDeprecated.vue';
import StandardAutoComplete from '@/components/standard-components/StandardAutoComplete.vue';
import StandardBadge from '@/components/standard-components/StandardBadge.vue';
import StandardButton from '@/components/standard-components/StandardButton.vue';
import StandardButtonGroup from '@/components/standard-components/StandardButtonGroup.vue';
import StandardButtonWithFreeformDropdown from '@/components/standard-components/StandardButtonWithFreeformDropdown.vue';
import StandardButtonWithMenu from '@/components/standard-components/StandardButtonWithMenu.vue';
import StandardButtonWithConfirmPopup from '@/components/standard-components/StandardButtonWithConfirmPopup.vue';
import StandardButtonWithSearchableMenu from '@/components/standard-components/StandardButtonWithSearchableMenu.vue';
import StandardCheckbox from '@/components/standard-components/StandardCheckbox.vue';
import StandardDrawer from '@/components/standard-components/StandardDrawer.vue';
import StandardFormDropdown from '@/components/standard-components/StandardFormDropdown.vue';
import StandardInputNumber from '@/components/standard-components/StandardInputNumber.vue';
import StandardInputText from '@/components/standard-components/StandardInputText.vue';
import StandardMenu from '@/components/standard-components/StandardMenu.vue';
import StandardMessage from '@/components/standard-components/StandardMessage.vue';
import StandardModal from '@/components/standard-components/StandardModal.vue';
import StandardMultiSelect from '@/components/standard-components/StandardMultiSelect.vue';
import StandardPopover from '@/components/standard-components/StandardPopover.vue';
import StandardSelect from '@/components/standard-components/StandardSelect.vue';
import StandardSentenceDropdown from '@/components/standard-components/StandardSentenceDropdown.vue';
import StandardSpinner from '@/components/standard-components/StandardSpinner.vue';
import StandardSwitch from '@/components/standard-components/StandardSwitch.vue';
import StandardTabs from '@/components/standard-components/StandardTabs.vue';
import StandardToolbar from '@/components/standard-components/StandardToolbar.vue';
import StandardDivider from '@/components/standard-components/StandardDivider.vue';
import StandardTooltip from '@/components/standard-components/StandardTooltip.vue';

export const GLOBAL_COMPONENTS = {
  ComponentWrapper,
  SectionTitle,
  SentenceDropdownDeprecated,
  StandardAutoComplete,
  StandardBadge,
  StandardButton,
  StandardButtonGroup,
  StandardButtonWithFreeformDropdown,
  StandardButtonWithMenu,
  StandardButtonWithConfirmPopup,
  StandardButtonWithSearchableMenu,
  StandardCheckbox,
  StandardDrawer,
  StandardFormDropdown,
  StandardInputNumber,
  StandardInputText,
  StandardMenu,
  StandardMessage,
  StandardModal,
  StandardMultiSelect,
  StandardPopover,
  StandardSelect,
  StandardSentenceDropdown,
  StandardSpinner,
  StandardSwitch,
  StandardTabs,
  StandardToolbar,
  StandardDivider,
  StandardTooltip,
} as const;

export const globalComponentsPlugin: Plugin = {
  install(app) {
    for (const [name, component] of Object.entries(GLOBAL_COMPONENTS)) {
      app.component(name, component as (typeof GLOBAL_COMPONENTS)[keyof typeof GLOBAL_COMPONENTS]);
    }
  },
};

type VueGlobalComponents = import('vue').GlobalComponents;

type Registered = keyof typeof GLOBAL_COMPONENTS;
type MissingInTypings = Exclude<Registered, keyof VueGlobalComponents>;

type AssertRegisteredAreTyped = MissingInTypings extends never ? true : MissingInTypings;

/**
 * NOTE: if there is a type error here, it means you added a global component above but not to
 * the GlobalComponents type in {@link file://./../types/globalComponents.d.ts}
 */
// oxlint-disable-next-line no-unused-vars
const _assertRegisteredAreTyped: AssertRegisteredAreTyped = true;
